<script>
import { getInitials } from "@/lib/utils"

export default {
  functional: true,

  props: {
    subscriber: { type: Object, default: null },
    small: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    fontSize: { type: String, default: null },
    defaultText: { type: String, default: "" }
  },

  render(h, { props, data }) {
    let classList = [data.staticClass, data.class]

    classList.push("subscriber-avatar")

    if (props.small) {
      classList.push("subscriber-avatar__sm")
    } else if (props.xSmall) {
      classList.push("subscriber-avatar__xs")
    }

    let imageUrl = null
    let text = ""

    if (props.subscriber) {
      const avatarUrls =
        props.subscriber.avatarUrls || props.subscriber.avatar_urls

      if (avatarUrls) {
        if (props.small) {
          imageUrl = avatarUrls.sm
        } else if (props.xSmall) {
          imageUrl = avatarUrls.xs
        } else {
          // integrate imageSize prop to change to a different size
          imageUrl = avatarUrls.sm
        }
      }

      text =
        props.subscriber.name ||
        props.subscriber.username ||
        props.subscriber.email ||
        props.subscriber.initials
    }

    text = text || props.defaultText
    const initials = props.subscriber?.initials
      ? props.subscriber.initials
      : getInitials(text)

    return (
      <div class={classList} style={{ fontSize: props.fontSize }}>
        {props.isLoading && (
          <div class="subscriber-avatar__loading">
            <v-loader />
          </div>
        )}

        {imageUrl ? (
          <div
            class="subscriber-avatar__image"
            style={{ backgroundImage: `url(${imageUrl})` }}
          ></div>
        ) : (
          <span title={text} class="subscriber-avatar__initials rounded-circle">
            {initials}
          </span>
        )}
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.subscriber-avatar {
  align-items: center;
  background-color: $color-ui--grey-20;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  color: $color-ui--grey-70;

  .subscriber-avatar__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color-rgb--white, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-loader {
    height: $size--6;
    width: $size--6;
  }
}

.subscriber-avatar__image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.subscriber-avatar__sm {
  height: 45px;
  width: 45px;
  min-height: 45px;
  min-width: 45px;
}

.subscriber-avatar__xs {
  height: $size--8;
  width: $size--8;
  min-height: $size--8;
  min-width: $size--8;

  font-size: 13px;
}
</style>
